import { Controllers } from 'lib/enums/routes/_controllers';
import { InvestorsRoutes } from 'lib/enums/routes/investors';
import {
  InvestorPrivateDoc,
  InvestorPrivateWhole,
  ManageInvestorPayload,
} from 'lib/interfaces/database/investor-private';
import { UserDoc, UserWhole } from 'lib/interfaces/database/user';
import { BaseService } from 'services/_base';

export class InvestorsService extends BaseService {
  private static instance: InvestorsService;

  static getInstance(): InvestorsService {
    if (!InvestorsService.instance) {
      InvestorsService.instance = new InvestorsService();
    }

    return InvestorsService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.investors,
    });
  }

  search(payload: Partial<InvestorPrivateDoc>) {
    return this.POST(
      {
        uri: InvestorsRoutes.Search,
      },
      payload
    )
      .then((result: InvestorPrivateWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: ManageInvestorPayload) {
    return this.POST(
      {
        uri: InvestorsRoutes.CreateOne,
      },
      payload
    )
      .then((result: InvestorPrivateWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // id belongs to the InvestorPrivate record, not the Investor record
  update(id: string, payload: ManageInvestorPayload) {
    return this.PUT(
      {
        uri: `${InvestorsRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: InvestorPrivateWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  createUser(investorID: string, payload: Partial<UserDoc>) {
    return this.POST(
      {
        uri: `${InvestorsRoutes.CreateUser}/${investorID}`,
      },
      payload
    )
      .then(
        (result: {
          investorPrivate: InvestorPrivateWhole;
          user: UserWhole;
        }) => {
          return result;
        }
      )
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
